import http from '../../http/common'
const resource = '/audit'
export default {
	get: (params) => http.get(`${resource}${params}`),
	auditHistory: (payload) => http.post(`${resource}/get`, payload),
}
